import {styled} from "@mui/material/styles";
import themedBoxShadow from "../styling/themedBoxShadow";

interface StyledPageImageProps {
    hideEffects?: boolean;
    isMobile: boolean;
}

const StyledPageImage = styled('img')<StyledPageImageProps>(({hideEffects, isMobile, theme}) => ({
    width: '100%',
    height: isMobile ? '220px' : '100%',
    objectFit: 'cover',
    display: 'block',
    ...(
        !hideEffects && {
            borderRadius: '0',
            boxShadow: isMobile ? themedBoxShadow(theme) : 'none',
        }
    )
}))

export default StyledPageImage;